function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#175664}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Help_and_info",
  "data-name": "Help and info",
  transform: "translate(-33 -466)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Help_and_info-2",
  "data-name": "Help and info",
  transform: "translate(-600.021 86.404)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4792",
  "data-name": "Path 4792",
  className: "cls-1",
  d: "M645.021 397.6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1 1 1 0 0 1 1 1v7a1 1 0 0 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4793",
  "data-name": "Path 4793",
  className: "cls-1",
  d: "M645.021 387.6a1 1 0 0 1-1-1 1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4794",
  "data-name": "Path 4794",
  className: "cls-1",
  d: "M645.021 403.6a12 12 0 1 1 12-12 12.014 12.014 0 0 1-12 12zm0-22a10 10 0 1 0 10 10 10.011 10.011 0 0 0-10-10z"
})));

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.f1c7e2ba.svg";
export { ForwardRef as ReactComponent };